import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "../../components/ui/card";
import { Skeleton } from "../../components/ui/skeleton";

export default function MatchesListSkeleton({ title = "Laddar matcher…", rows = 4 }) {
    return (
        <Card className="bg-[hsl(var(--card))] border-[hsl(var(--border))]">
            <CardHeader>
                <CardTitle className="text-white">{title}</CardTitle>
            </CardHeader>
            <CardContent className="divide-y divide-[hsl(var(--border))]">
                {[...Array(rows)].map((_, i) => (
                    <div key={i} className="py-3 flex items-center justify-between">
                        <div className="flex items-center gap-3 min-w-0">
                            <Skeleton className="h-5 w-16 rounded" />
                            <div className="min-w-0">
                                <Skeleton className="h-4 w-40 mb-1 rounded" />
                                <Skeleton className="h-3 w-28 rounded" />
                            </div>
                        </div>
                        <Skeleton className="h-5 w-5 rounded-full" />
                    </div>
                ))}
            </CardContent>
        </Card>
    );
}
